import React from "react";
//import { ErrorBoundary } from "react-error-boundary";
import {
  BrowserRouter as Router,
  Redirect,
  Route,
  Switch,
} from "react-router-dom";
import "bootstrap/dist/css/bootstrap.min.css";
import "./App.css";
import PageNotFound from "./PageNotFound";
import PrivateRoute from "./PrivateRoute";
import PublicRoute from "./PublicRoute";
import Login from "./Components/Login";
import Dashboard from "./Components/Dashboard";

// function ErrorFallback({ error, resetErrorBoundary }) {
//   return (
//     <div role="alert">
//       <p>Something went wrong:</p>
//       <pre>{error.message}</pre>
//       <button onClick={resetErrorBoundary}>Try again</button>
//     </div>
//   );
// }

const NoFound = () => {
  return <Redirect to="/page-not-found" />;
};

function App() {
  return (
    //<ErrorBoundary FallbackComponent={ErrorFallback}>
    <Router basename={"/admin"}>
      <Switch>
        <PublicRoute restricted={true} exact path="/" component={Login} />
        <PublicRoute path="/create-password" component={Login} />
        <PrivateRoute path="/reset-password" component={Login} />
        <PrivateRoute path="/dashboard" component={Dashboard} />
        <PublicRoute
          restricted={true}
          exact
          path="/forgot-password"
          component={Login}
        />
        <PublicRoute
          restricted={true}
          exact
          path="/otp-validate"
          component={Login}
        />
        <Route path="/page-not-found" component={PageNotFound} />
        <Route exact strict component={() => NoFound()} />
      </Switch>
    </Router>
    //</ErrorBoundary>
  );
}

export default App;
